import { Box } from '@hivebrite/design-system/Box';
import { DefaultLink } from '@hivebrite/design-system/Link';

import { isMobileApp } from 'hb-react/shared/utils/mobile';
import * as mobileDeviceFromUserAgent from 'helpers/mobileDeviceFromUserAgent';

const LoginSignup = ({ settings }) => {
  const {
    body_text: bodyText,
    enabled,
    link_text: linkText,
    remove_signup_in_app: removeSignupInApp,
    url,
  } = settings;
  const enabledOnMobile = !(
    (isMobileApp() || mobileDeviceFromUserAgent.any()) &&
    removeSignupInApp
  );

  return enabled && enabledOnMobile ? (
    <>
      <Box mb={2} mt={7} flexDirection="column" textAlign="center">
        {bodyText}
      </Box>
      <Box mt={3} mb={3} flexDirection="column" textAlign="center">
        <DefaultLink href={url}>{linkText}</DefaultLink>
      </Box>
    </>
  ) : null;
};

export default LoginSignup;
